import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de8a4614"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row mt-1 mb-4 ps-5 justify-content-center"
}
const _hoisted_2 = { class: "membership-banner" }
const _hoisted_3 = { class: "banner-content" }
const _hoisted_4 = { class: "banner-title" }
const _hoisted_5 = { class: "text-white" }
const _hoisted_6 = { class: "text-purple" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "text-white" }
const _hoisted_9 = { class: "text-white" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-button-bg" }, null, -1))
const _hoisted_12 = { class: "banner-button-text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/media/hc/lux_1.png",
  class: "banner-illustration",
  alt: "Hacking Club Illustration"
}, null, -1))

import { computed } from "vue";
import { useStore } from "vuex";
import type { ModernSubscription, ModernUser } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const user = computed<ModernUser>(() => (store.getters.currentUser ?? {}) as ModernUser);
const currentLanguage = computed(
  () => store.getters.getCurrentLanguage || localStorage.getItem("currentLanguage") || "en"
);

const goToPlans = () => {
  const url = `${process.env.VUE_APP_CHECKOUT_URL}/plans`;
  window.open(url, "_blank", "noopener,noreferrer");
};

const showBanner = computed(() => {
  const subscriptions = (user.value.subscriptions ?? []) as ModernSubscription[];
  const activeSubscriptions = subscriptions.filter((sub) => sub.status === "active");
  return activeSubscriptions.length === 1 && activeSubscriptions[0].plan_id === 1;
});

return (_ctx: any,_cache: any) => {
  return (_unref(showBanner))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.membership_banner_title_part1`)), 1),
              _createElementVNode("span", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.membership_banner_title_part2_a`)), 1),
                _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.membership_banner_title_part2_b`)), 1)
              ]),
              _createElementVNode("span", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.membership_banner_title_part3`)), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "banner-button",
              onClick: goToPlans
            }, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.membership_banner_button`)), 1)
            ])
          ]),
          _hoisted_13
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})